import { render, staticRenderFns } from "./processAccidentRegister.vue?vue&type=template&id=09c52655"
import script from "./processAccidentRegister.vue?vue&type=script&lang=js"
export * from "./processAccidentRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c52655')) {
      api.createRecord('09c52655', component.options)
    } else {
      api.reload('09c52655', component.options)
    }
    module.hot.accept("./processAccidentRegister.vue?vue&type=template&id=09c52655", function () {
      api.rerender('09c52655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/processAccidentRegister.vue"
export default component.exports